export var TokenType;
(function (TokenType) {
    TokenType[TokenType["Pair"] = 0] = "Pair";
    TokenType[TokenType["Operator"] = 1] = "Operator";
    TokenType[TokenType["GroupStart"] = 2] = "GroupStart";
    TokenType[TokenType["GroupEnd"] = 3] = "GroupEnd";
})(TokenType || (TokenType = {}));
export var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["AND"] = "AND";
    LogicalOperator["OR"] = "OR";
    LogicalOperator["NOT"] = "NOT";
})(LogicalOperator || (LogicalOperator = {}));
export function tokenizeSigdexQuery(input) {
    const tokens = [];
    let i = 0;
    const eat = (regex) => {
        regex.lastIndex = i;
        const match = regex.exec(input);
        if (match) {
            i = regex.lastIndex;
            return match[0];
        }
        return null;
    };
    while (i < input.length) {
        eat(/\s*/y); // skip whitespace
        if (input[i] === '(') {
            tokens.push({ type: TokenType.GroupStart });
            i++;
            continue;
        }
        if (input[i] === ')') {
            tokens.push({ type: TokenType.GroupEnd });
            i++;
            continue;
        }
        let opMatch = eat(/(?:\b(AND|OR|NOT)\b|(?<=\s)[&|](?=\s))/iy);
        if (opMatch) {
            if (opMatch === '&')
                opMatch = 'AND';
            if (opMatch === '|')
                opMatch = 'OR';
            tokens.push({
                type: TokenType.Operator,
                value: LogicalOperator[opMatch.toUpperCase()],
            });
            continue;
        }
        const negated = input[i] === '-';
        if (negated)
            i++;
        const keyMatch = eat(/\w+/y);
        if (!keyMatch)
            break;
        let key = keyMatch;
        let value = '';
        let isRegex = false;
        if (input[i] === ':') {
            i++;
            if (input[i] === '"' || input[i] === "'") {
                const quote = input[i];
                i++;
                // to-do allow quote escape \" once i have a use case for it
                const end = input.indexOf(quote, i);
                if (end === -1)
                    throw new Error('Unterminated quoted string');
                value = input.slice(i, end);
                i = end + 1;
            }
            else if (input[i] === '/') {
                i++;
                const end = input.indexOf('/', i);
                if (end === -1)
                    throw new Error('Unterminated regex');
                value = input.slice(i, end);
                isRegex = true;
                i = end + 1;
            }
            else {
                const valMatch = eat(/[^\s)]+/y);
                if (!valMatch)
                    throw new Error('Expected value after colon');
                value = valMatch;
            }
        }
        else {
            const cmpMatch = eat(/(<=|>=|=|<|>)/y);
            if (!cmpMatch)
                throw new Error(`Expected ':' or comparison after key '${key}'`);
            const valMatch = eat(/[^\s)]+/y);
            if (!valMatch)
                throw new Error('Expected value after comparison');
            value = `${cmpMatch}${valMatch}`;
        }
        tokens.push({ type: TokenType.Pair, key, value, negated, isRegex });
    }
    return tokens;
}
